export default __webpack_public_path__ + "static/media/home_find_ideal_bg.4063f7c0.png";